import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import BoxCard from './BoxCard';

const CARD_W = 300;

export default function SortableCard({ box, index, color, isMobile, onDrillIn, onEdit, onDelete, onUpdate, onToggleSpan, onAskAI, canSetPrivate, compactView, lockedBy }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: box.id, disabled: !!lockedBy });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.3 : 1,
    gridColumn: (box.span || 1) >= 2 ? 'span 2' : 'span 1',
  };
  return (
    <div ref={setNodeRef} style={style}>
      <BoxCard
        box={box} depth={0} index={index} color={color} isMobile={isMobile}
        onDrillIn={onDrillIn} onEdit={onEdit} onDelete={onDelete}
        onUpdate={onUpdate} onToggleSpan={onToggleSpan} onAskAI={onAskAI}
        canSetPrivate={canSetPrivate}
        compactView={compactView}
        lockedBy={lockedBy}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </div>
  );
}
